<template>
  <div class="conteiner-modal-copy" v-if="show" @click.self="close" id="modal-copy">
    <div class="modal-copy">
      <div class="modal-header-copy">
         <div class="area-btn-close-modal-copy" @click="close">
            <img src="@/assets/imgs/icone_fechar_cinza.svg" alt />
          </div>
      </div>
      <div class="modal-body-copy">
        <textarea id="target-copy">{{ text }}</textarea>
      </div>
      <div class="modal-footer-copy">
        <div class="modal-actions-copy">
          <transition name="fade">
            <span v-if="showAlert" class="alerta-texto-acao-modal-copy">Texto salvo na área de transferência!</span>
          </transition>
          <button class="button-copy-secunary" @click="close">Cancelar</button>
          <button class="button-copy-primary" @click="copyText">Copiar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ModalCopy",
  data() {
    return {
      showAlert: false,
    }
  },

  computed: {
    ...mapGetters("modalCopyStore", {
      show: "modalShow",
      text: "text",
    }),
  },
  methods: {
    ...mapActions({
      close: "modalCopyStore/hide"
    }),
    copyText() {
      if (document.getSelection().rangeCount > 0) {
        document.getSelection().removeAllRanges();
      }

      document.getElementById("target-copy").select();

      document.execCommand('copy');

      this.showAlert = true;

      setTimeout(() => this.showAlert = false, 3000);
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.conteiner-modal-copy {
  overflow: hidden;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,.4);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 45;
  left: 0;
  top: 0;
  padding-top: 10em;

  & .modal-copy {
    margin: auto;
    padding: 0;
    width: 50em;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;

    & .modal-header-copy {
      display: flex;
      margin: 0;
      padding: 1rem 1rem 0 1rem;
      align-content: center;
      justify-content: flex-end;

      & .area-btn-close-modal-copy {
        opacity: .5;
        cursor: pointer;

        & img {
          border-radius: .25rem;
          width: 1.75em;
          height: 1.75em;
        }
      }
    }

    & .modal-body-copy {
      padding: 1rem;

      & textarea {
        width: 46.4rem;
        height: 14em;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        overflow: auto;
      }
    }

    & .modal-footer-copy {
      display: flex;
      margin: 0;
      padding: 1rem;
      align-content: center;
      justify-content: flex-end;

      & .modal-actions-copy {

        button {
          cursor: pointer;
          margin-right: .25rem;
          -webkit-appearance: button;
          display: inline-block;
          font-weight: 400;
          text-align: center;
          white-space: nowrap;
          user-select: none;
          border: 1px solid transparent;
          padding: .375rem .75rem;
          font-size: 1rem;
          line-height: 1.5;
          border-radius: .25rem;
          transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        }
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.alerta-texto-acao-modal-copy {
  margin-right: 6rem;
  color: #7e00bd;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
  margin-top: .25rem;
}

.button-copy-primary {
  background-color: $cor_roxo;
  border-color: $cor_roxo;
  color: #fff;

  &:hover {
    background-color: $cor_roxo_dark;
    border-color:  $cor_roxo_dark;
  }
}

.button-copy-secunary {
  background-color: $cor_cinza;
  border-color: $cor_cinza;
  color: #fff;

  &:hover {
    background-color: $cor_cinza_dark;
    border-color: $cor_cinza_dark;
  }
}

@media all and (min-width: 680px) and (max-width: 800px) {
  .conteiner-modal-copy {
    padding-top: 6em;
    background-color: inherit;

    & .modal-copy {
      width: 100%;
      border-radius: inherit;
      height: inherit;
      overflow: scroll;

      & .modal-body-copy {
        & textarea {
          width: 100%;
          width: -moz-available;
          width: -webkit-fill-available;
          height: 16rem;
        }
      }
    }
  }
}

@media all and (max-width: 679px) {
  .conteiner-modal-copy {
    padding-top: 4em;
    background-color: inherit;
    z-index: 8001;

    & .modal-copy {
      width: 100%;
      border-radius: inherit;
      height: inherit;
      position: fixed;
      z-index: 8001;
      overflow: scroll;

      & .modal-body-copy {
        & textarea {
          width: 100%;
          width: -moz-available;
          width: -webkit-fill-available;
          height: 16rem;
        }
      }

      & .modal-footer-copy {
        justify-content: inherit;

        & .modal-actions-copy {
          display: flex;
          flex-direction: column-reverse;
          width: 100%;
          width: -moz-available;
          width: -webkit-fill-available;

          button {
            width: 100%;
            margin-top: .5rem;
            height: 3.5rem;
            font-size: 1.25rem;
          }

          span {
            margin-right: 0;
            text-align: center;
          }
        }
      }
    }
  }

  .alerta-texto-acao-modal-copy {
    margin-top: .5rem;
    text-align: center;
  }
}
</style>
